import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import {  EligibilityStatementRES } from '@program-suite/data-common';

@Injectable({
  providedIn: 'root',
})
export class ProgramGuidelinesService {
  http = inject(HttpClient);
  controller = 'EligibilityStatement';

  async getEligibilityStatement(model: any): Promise<EligibilityStatementRES> {
    try {
      return await firstValueFrom(
        this.http.get<EligibilityStatementRES>('EligibilityStatement',{params: model})
      );
    } catch (error) {
      throw error;
    }
  }
}